import './App.css';

function App() {
  const handleClick = () => {
    window.location.href = 'http://13.125.63.168:8080/';
  };

  return (
    <div className="App">
      <header className="App-header">
        <button onClick={handleClick}>서버로 이동</button>
      </header>
    </div>
  );
}

export default App;
